import { Grid, Text } from '@wework/dieter-ui'
import React from 'react'
import parseISO from 'date-fns/parseISO'
import format from 'date-fns/format'

export default function History({ attribute, created_at, fullname }) {
  return (
    <Grid columns={4} style={{ marginTop: 16 }}>
      {/* <Grid.Column width="2">
        <Avatar size="small" src={holdPattern} />
      </Grid.Column> */}
      <Grid.Column width="5">
        <Text size="small" primary>
          {fullname}
        </Text>
      </Grid.Column>
      <Grid.Column width="8">
        <Grid>
          <Grid.Row>
            <Grid.Column width="8">
              <Text size="small">{attribute.property}</Text>
            </Grid.Column>
            <Grid.Column width="8">
              <Text size="small">
                {attribute.old_value} {'->'} {attribute.new_value}
              </Text>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Column>
      <Grid.Column width="3">
        <Text size="small">{format(parseISO(created_at), 'p')}</Text>
      </Grid.Column>
    </Grid>
  )
}
